import {
    RouteObject,
    Navigate,
    useLocation,
    useSearchParams,
} from 'react-router-dom'
import { MyTargetPerformance } from './myTarget-performance'
import { Guest } from './guest'
import { Financial } from './financial'
import { Team } from './team'
import { MetricDetails } from './metric-details'
import { isStore } from 'utils/location'

const RedirectToGuest = () => {
    const location = useLocation()
    return <Navigate to={`guest${location.search}`} replace />
}

const MetricDetailsOrRedirect = () => {
    const [searchParams] = useSearchParams()
    const tab = searchParams.get('tab') || 'guest'
    const locationIdParam = searchParams.get('locationId')

    if (locationIdParam && isStore(locationIdParam)) {
        return (
            <Navigate
                to={`/mytarget-performance/${tab}?locationId=${locationIdParam}`}
                replace
            />
        )
    }

    return <MetricDetails />
}

export const MyTargetPerformanceRoute: RouteObject = {
    path: '/mytarget-performance',
    element: <MyTargetPerformance />,
    children: [
        { index: true, element: <RedirectToGuest /> },
        { path: 'guest', element: <Guest /> },
        { path: 'financial', element: <Financial /> },
        { path: 'team', element: <Team /> },
        { path: 'details/:metricName', element: <MetricDetailsOrRedirect /> },
    ],
}
